import { useContext } from 'react'

import { WebRTC } from './WebRTC'
import { webRTCContext } from './context'

export function useWebRTC(): WebRTC {
  const webRTC = useContext(webRTCContext)

  if (!webRTC) throw new Error('WebRTC not found in tree')

  return webRTC
}
